/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SettingsSalestypesQueryResponse } from '../../types/GetV1SettingsSalestypes.ts'

export const getV1SettingsSalestypesQueryKey = () => [{ url: '/v1/settings/salestypes' }] as const

export type GetV1SettingsSalestypesQueryKey = ReturnType<typeof getV1SettingsSalestypesQueryKey>

/**
 * {@link /v1/settings/salestypes}
 */
export async function getV1SettingsSalestypes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1SettingsSalestypesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/settings/salestypes`, ...requestConfig })
    return res
}

export function getV1SettingsSalestypesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SettingsSalestypesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SettingsSalestypesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SettingsSalestypesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1SettingsSalestypes(config)
        },
    })
}

/**
 * {@link /v1/settings/salestypes}
 */
export function useGetV1SettingsSalestypes<
    TData = ResponseConfig<GetV1SettingsSalestypesQueryResponse>,
    TQueryData = ResponseConfig<GetV1SettingsSalestypesQueryResponse>,
    TQueryKey extends QueryKey = GetV1SettingsSalestypesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SettingsSalestypesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SettingsSalestypesQueryKey()

    const query = useQuery(
        {
            ...getV1SettingsSalestypesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
